module.exports = __webpack_public_path__ + "media/newcamellia.7dc7603f.mp4";